import * as yup from 'yup';

export const predictiveScalingValidationSchema = yup.object({
  cpu: yup.object({
    enabled: yup.boolean().required(),
  }),
});
